
import React from 'react';
import {ImageInput, ImageField, CheckboxGroupInput, FormDataConsumer, NumberInput, ReferenceArrayInput, AutocompleteArrayInput, TextInput, 
    RadioButtonGroupInput, Create, SimpleForm, SelectInput, required, number, useTranslate} 
from 'react-admin';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import Typography from '@material-ui/core/Typography';
import { DateInput, DateTimeInput } from 'react-admin-date-inputs2';

import MomentUtils from '@date-io/moment';
// import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import frLocale from "date-fns/locale/fr";
import DateFnsUtils from '@date-io/date-fns';
import {generateRandom} from "../../util/function"
import {unitTypes} from '../../util/constant'

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    inlineBlock: { display: 'inline-flex', marginRight: '1rem' },
    colorLabel: { paddingLeft: 0, color: '#c30040', marginTop: '0px'},
    
    colorPrimary: {color:'#c30040',},
    
    noColorLabel: {paddingLeft: 50,  
    },

    colorValue: {color: '#c30040',paddingLeft:5},

    supplementText: {color: '#c30040',},

    noHeader:{display:'none',
    // height:'1px'
    },

    image:{width:'200px',height:'200px', borderRadius: '50%'},

    
});

// import { DateInput } from 'react-admin-date-inputs2';
// import { DateInput } from 'react-admin-date-inputs2';
// import DateFnsUtils from '@date-io/date-fns';
// import MomentUtils from 'material-ui-pickers/utils/moment-utils';
// import frLocale from "date-fns/locale/fr";

// DateFnsUtils.prototype.getStartOfMonth = DateFnsUtils.prototype.startOfMonth

// import Strings from '../res/strings';


const Title = ({ record }) => {
    const translate = useTranslate();
    return <span>{translate('resources.product.create')}</span>;
};

const validatePositive = (value, allValues) => {
    if (value <= 0) {
        return 'Doit être plus grand que 0';
    }
    return [];
};

const validateGreaterThanZero = (value, allValues) => {
    if (value < 1) {
        return 'Doit être au moins 1';
    }
    return [];
};

const validateValue = [required(), number(), validatePositive];
const validateMaxCount = [required(), number(), validateGreaterThanZero];

const Aside = () => (
    <div style={{ width: 200, margin: '1em' }}>
        <Typography variant="body2">Mettez #code dans le titre ou la description si vous voulez le code apparaît dans le titre ou la description respectivement</Typography>
        
        {/* <Typography variant="body2">
            Posts will only be published once an editor approves them
        </Typography> */}
    </div>
);

const clientNameField = choice => choice != null ? `${choice.first_name} ${choice.last_name} (${choice.email})` : '';

const CreateProduct = props => {
    const translate = useTranslate();
    const classes = useStyles();
    const uploadFileText = translate('ra.input.file.upload_single') + '(' + translate('max_size') + '500KB)';

    return(
    <Create title={<Title/>} {...props}>
        <SimpleForm redirect="list">

            <TextInput source="ref" label = "Référence du produit" validate={required()}/>
            <TextInput source="name" label = "Nom du produit" validate={required()} fullWidth={true} />
            <TextInput source="description" label = "Description" multiline="true" fullWidth={true} validate={required()}/>
            <NumberInput source="price" label = "Prix HT / unité (€)" min={0.01} step={0.01} validate={validateValue}/>
            <NumberInput source="vat" label = "Taux de TVA (%)" min={1} step={1} validate={validateValue}/>
            
            <ImageInput source="photo" label="Photo du produit" accept="image/*" maxSize='600000' placeholder={uploadFileText}>
                <ImageField source="url" title="Fichier" />
            </ImageInput>

            <CheckboxGroupInput source="order_types" label="Types de commande" choices={[
                 { id: '0', name: 'Immédiate' }, { id: '1', name: "Réservation à l'avance" },
            ]} />

             <RadioButtonGroupInput source="locked" label="Verrouillé ?" 
            choices={[
                { id: '0', name: 'Non' },
                { id: '1', name: 'Oui' },
            ]} initialValue='0'/>
         

            
{/* 
            <DateTimeInput source="begin_date" label="Date de debut"
            autoComplete="" options={{ format: 'dd/MM/yyyy HH:mm' }} 
                 providerOptions={{ utils: DateFnsUtils, locale: frLocale }}
            />
            <DateTimeInput source="end_date" label="Date de fin"
            autoComplete="" options={{ format: 'dd/MM/yyyy HH:mm' }} 
                 providerOptions={{ utils: DateFnsUtils, locale: frLocale }}
            /> */}
        </SimpleForm>
    </Create>
)};

export default CreateProduct;
